/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { Component, OnInit } from '@angular/core';
import { isDevMode } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute, ChildActivationEnd, ActivationEnd } from '@angular/router';
import { PrintService } from 'app/print/print.service';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  constructor(router: Router, activatedRoute: ActivatedRoute, public printService: PrintService, private titleService: Title) {
    if (isDevMode()) {
      console.log('----------DEVELOPMENT MODE-------------');
    }

    switch (environment.name) {
      case 'LIVE':
        titleService.setTitle('Orbit Tickets');
        break;
      case 'UAT':
        titleService.setTitle('[UAT] Orbit Tickets');
        break;
      case 'TEST':
        titleService.setTitle('[TEST] Orbit Tickets');
        break;
      case 'DEV':
        titleService.setTitle('[DEV] Orbit Tickets');
        break;
      default:
        titleService.setTitle('[UNKNOWN] Orbit Tickets');
        break;
    }
  }
}
